



















































import { defineComponent, PropType, computed } from '@vue/composition-api';
import FormInput from '@front-app/components/form/FormInput.vue';
import { ApiMonthOption } from './monthPickerUtil';
import MonthPicker from './MonthPicker.vue';

export default defineComponent({
	components: {
		FormInput,
		MonthPicker,
	},
	props: {
		value: {
			type: Date as PropType<Date | null>,
			default: null,
		},
		yearId: {
			type: String,
			required: true,
		},
		yearPlaceholder: {
			type: String,
			required: true,
		},
		dayPlaceholder: {
			type: String,
			required: true,
		},
		yearMaxLength: {
			type: Number,
			default: () => new Date().getFullYear().toString().length,
		},
		required: Boolean,
		hasError: Boolean,
	},
	setup(props, ctx) {
		const yearValue = computed(() => props.value?.getFullYear());
		// month-picker expects a one-indexed month
		const monthValue = computed(() => {
			if (!props.value) {
				return ApiMonthOption.NONE;
			}
			return props.value.getMonth() + 1;
		});
		const dayValue = computed(() => props.value?.getDate());
		const monthLengthInDays = computed((): number | undefined => {
			const year = yearValue.value;
			const month = monthValue.value;
			if (!props.value || !year || !month) {
				return 0;
			}
			return (new Date(year, month + 1, 0)).getDate();
		});

		// Javascript hates years before 1902. If you use the standard date constructor like
		// new Date(2, 1, 1) this will give Sat Feb 01 1902 00:00:00 GMT+XXXX
		const updateDate = (y?: number, m?: number, d?: number) => {
			const year = String(y || new Date().getFullYear()).padStart(4, '0');
			const month = String((!m || m < 1) ? 1 : m).padStart(2, '0');
			const day = String(d || 1).padStart(2, '0');
			const newDate = new Date(`${year}-${month}-${day}T00:00:00`);
			ctx.emit('input', newDate);
		};
		const updateYear = (year: string) => {
			if (!year) {
				return;
			}
			updateDate(parseInt(year, 10), monthValue.value, dayValue.value);
		};
		const updateMonth = (month: number) => {
			if (!month) {
				return;
			}
			updateDate(yearValue.value, month, dayValue.value);
		};
		const updateDay = (day: string) => {
			if (!day) {
				return;
			}
			updateDate(yearValue.value, monthValue.value, parseInt(day, 10));
		};
		return {
			yearValue,
			monthValue,
			dayValue,
			monthLengthInDays,
			updateYear,
			updateMonth,
			updateDay,
		};
	},
});
